import { createSlice } from "@reduxjs/toolkit";
import { FetchingTypes } from "../interfaces/types";
import { FilterProps, PriceProps } from "../interfaces/app";

export interface FiltersStateProps {
    filters: {
        fetching: FetchingTypes;
    };
    brands: FilterProps;
    models: FilterProps;
    brandSelected: object[];
    modelSelected: object[];
    vehicleTypeSelected: string;
    vehicleCategorySelected: any;
    yearSelected: number[];
    priceSelected: PriceProps;
    page: number;
    mileageSelected: object[];
    colorSelected: string[];
    fuelSelected: string[];
    typeSelected: object[];
    regionSelected: string[];
    transmissionSelected: string[];
    colors: any;
    fuels: FilterProps;
    regions: FilterProps;
    transmissions: FilterProps;
    years: FilterProps;
    types: FilterProps;
    dealerships: FilterProps;
}

const initialState: FiltersStateProps = {
    filters: {
        fetching: "unknown"
    },
    brands: {
        fetching: "unknown",
        data: []
    },
    models: {
        fetching: "unknown",
        data: []
    },
    brandSelected: [],
    modelSelected: [],
    vehicleTypeSelected: "used",
    vehicleCategorySelected: ["Autos"],
    yearSelected: [],
    priceSelected: {
        min: "",
        max: ""
    },
    mileageSelected: [],
    colorSelected: [],
    fuelSelected: [],
    typeSelected: [],
    regionSelected: [],
    transmissionSelected: [],
    page: 1,
    colors: {
        fetching: "unknown",
        data: []
    },
    fuels: {
        fetching: "unknown",
        data: []
    },
    regions: {
        fetching: "unknown",
        data: []
    },
    transmissions: {
        fetching: "unknown",
        data: []
    },
    years: {
        fetching: "unknown",
        data: []
    },
    types: {
        fetching: "unknown",
        data: []
    },
    dealerships: {
        fetching: "unknown",
        data: []
    }
};


const filtersSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        getFiltersRequest: (state) => {
            state.filters.fetching = "loading";
        },
        getFiltersSuccess: (state) => {
            state.filters.fetching = "success";
        },
        getFiltersFailure: (state) => {
            state.filters.fetching = "failure";
        },
        cleanFilters: (state) => {
            state.brandSelected = initialState.brandSelected;
            state.modelSelected = initialState.modelSelected;
            state.yearSelected = initialState.yearSelected;
            state.priceSelected = initialState.priceSelected;
            state.mileageSelected = initialState.mileageSelected;
            state.colorSelected = initialState.colorSelected;
            state.fuelSelected = initialState.fuelSelected;
            state.typeSelected = initialState.typeSelected;
            state.regionSelected = initialState.regionSelected;
            state.transmissionSelected = initialState.transmissionSelected;
            state.vehicleTypeSelected = initialState.vehicleTypeSelected;
            state.vehicleCategorySelected = initialState.vehicleCategorySelected;
            state.filters.fetching = initialState.filters.fetching;
        },
        // Brands
        getBrandsRequest: (state) => {
            state.brands.fetching = "loading";
        },
        getBrandsSuccess: (state, action) => {
            state.brands.fetching = "success";
            state.brands.data = action.payload;
        },
        getBrandsFailure: (state) => {
            state.brands.fetching = "failure";
        },
        // Dealerships
        getDealershipsRequest: (state) => {
            state.dealerships.fetching = "loading";
        },
        getDealershipsSuccess: (state, action) => {
            state.dealerships.fetching = "success";
            state.dealerships.data = action.payload;
        },
        getDealershipsFailure: (state) => {
            state.dealerships.fetching = "failure";
        },
        // Models
        getModelsRequest: (state) => {
            state.models.fetching = "loading";
        },
        getModelsSuccess: (state, action) => {
            state.models.fetching = "success";
            state.models.data = action.payload;
        },
        getModelsFailure: (state) => {
            state.models.fetching = "failure";
        },
        updateModels: (state, action) => {
            state.models.data = action.payload;
        },
        // TODO SER CONSISTENTE CON LOS NOMBRES
        // SI ES ARRAY EL NOMBRE DEBE SER PLURAL
        // Colors
        getColorRequest: (state) => {
            state.colors.fetching = "loading";
        },
        getColorSuccess: (state, action) => {
            state.colors.fetching = "success";
            state.colors.data = action.payload;
        },
        getColorFailure: (state) => {
            state.colors.fetching = "failure";
        },
        // TODO SER CONSISTENTE CON LOS NOMBRES
        // SI ES ARRAY EL NOMBRE DEBE SER PLURAL
        // Fuels
        getFuelRequest: (state) => {
            state.fuels.fetching = "loading";
        },
        getFuelSuccess: (state, action) => {
            state.fuels.fetching = "success";
            state.fuels.data = action.payload;
        },
        getFuelFailure: (state) => {
            state.fuels.fetching = "failure";
        },
        // Regions
        getRegionsRequest: (state) => {
            state.regions.fetching = "loading";
        },
        getRegionsSuccess: (state, action) => {
            state.regions.fetching = "success";
            state.regions.data = action.payload;
        },
        getRegionsFailure: (state) => {
            state.regions.fetching = "failure";
        },
        // TODO SER CONSISTENTE CON LOS NOMBRES
        // SI ES ARRAY EL NOMBRE DEBE SER PLURAL
        // Transmissions
        getTransmissionRequest: (state) => {
            state.transmissions.fetching = "loading";
        },
        getTransmissionSuccess: (state, action) => {
            state.transmissions.fetching = "success";
            state.transmissions.data = action.payload;
        },
        getTransmissionFailure: (state) => {
            state.transmissions.fetching = "failure";
        },
        // Years
        getYearsRequest: (state) => {
            state.years.fetching = "loading";
        },
        getYearsSuccess: (state, action) => {
            state.years.fetching = "success";
            state.years.data = action.payload;
        },
        getYearsFailure: (state) => {
            state.years.fetching = "failure";
        },
        // TODO SER CONSISTENTE CON LOS NOMBRES
        // SI ES ARRAY EL NOMBRE DEBE SER PLURAL
        // Types
        getTypeCarRequest: (state) => {
            state.types.fetching = "loading";
        },
        getTypeCarSuccess: (state, action) => {
            state.types.fetching = "success";
            state.types.data = action.payload;
        },
        getTypeCarFailure: (state) => {
            state.types.fetching = "failure";
        },
        // Setters
        setBrand: (state, action) => {
            state.brandSelected = action.payload;
        },
        setModel: (state, action) => {
            state.modelSelected = action.payload;
        },
        setYear: (state, action) => {
            state.yearSelected = action.payload;
        },
        setVehicleType: (state, action) => {
            state.vehicleTypeSelected = action.payload;
        },
        setPrice: (state, action) => {
            state.priceSelected.min = action.payload.min;
            state.priceSelected.max = action.payload.max;
        },
        setMileage: (state, action) => {
            state.mileageSelected = action.payload;
        },
        setColor: (state, action) => {
            state.colorSelected = action.payload;
        },
        setFuel: (state, action) => {
            state.fuelSelected = action.payload;
        },
        setType: (state, action) => {
            state.typeSelected = action.payload;
        },
        setRegion: (state, action) => {
            state.regionSelected = action.payload;
        },
        setTransmission: (state, action) => {
            state.transmissionSelected = action.payload;
        },
        setVehicleCategory: (state, action) => {
            state.vehicleCategorySelected = action.payload;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        }
    }
});

export const {
    getFiltersRequest,
    getFiltersSuccess,
    getFiltersFailure,
    cleanFilters,
    getBrandsRequest,
    getBrandsSuccess,
    getBrandsFailure,
    getModelsRequest,
    getModelsSuccess,
    getModelsFailure,
    updateModels,
    getColorRequest,
    getColorSuccess,
    getColorFailure,
    getFuelRequest,
    getFuelSuccess,
    getFuelFailure,
    getRegionsRequest,
    getRegionsSuccess,
    getRegionsFailure,
    getTransmissionRequest,
    getTransmissionSuccess,
    getTransmissionFailure,
    getDealershipsRequest,
    getDealershipsSuccess,
    getDealershipsFailure,
    getYearsRequest,
    getYearsSuccess,
    getYearsFailure,
    getTypeCarRequest,
    getTypeCarSuccess,
    getTypeCarFailure,
    setBrand,
    setModel,
    setYear,
    setVehicleType,
    setPrice,
    setMileage,
    setColor,
    setFuel,
    setType,
    setRegion,
    setTransmission,
    setVehicleCategory,
    setPage
} = filtersSlice.actions;

export default filtersSlice.reducer;